var _path, _g, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDecentralized(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 58,
    viewBox: "0 0 54 58",
    width: 54,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m33.2205 20.3038-5.7275-3.1166c-.5961-.3244-1.3159-.3244-1.9119-.0001l-5.7278 3.1167m13.3672 0-6.6835 3.6368m6.6835-3.6368-.0002 6.0853c0 .7326-.4005 1.4065-1.044 1.7567l-5.6393 3.0689m0-7.2741-6.6837-3.6368m6.6837 3.6368v7.2741m-6.6837-10.9109.0002 6.0855c0 .7326.4006 1.4065 1.0441 1.7567l5.6394 3.0687",
    stroke: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#00cde2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m43.2462 24.5004c0 2.1631 1.7455 3.9167 3.8988 3.9167 2.1532 0 3.8988-1.7536 3.8988-3.9167s-1.7456-3.9167-3.8988-3.9167c-2.1533 0-3.8988 1.7536-3.8988 3.9167zm0 0h-7.2406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.82795 24.5004c0 2.1631-1.74554 3.9167-3.89878 3.9167-2.15323 0-3.89877-1.7536-3.89877-3.9167s1.74554-3.9167 3.89877-3.9167c2.15324 0 3.89878 1.7536 3.89878 3.9167zm0 0h7.24055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.4514 13.5307c.9141.9183 2.3962.9183 3.3103 0s.9141-2.4072 0-3.3255c-.9141-.91835-2.3962-.91835-3.3103 0-.9142.9183-.9142 2.4072 0 3.3255zm0 0-3.6782 3.695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.9184 13.5307c-.9141.9183-2.3962.9183-3.3103 0s-.9141-2.4072 0-3.3255c.9141-.91835 2.3962-.91835 3.3103 0 .9141.9183.9141 2.4072 0 3.3255zm0 0 3.6782 3.695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.4514 35.1619c.9141-.9183 2.3962-.9183 3.3103 0 .9141.9184.9141 2.4072 0 3.3256-.9141.9183-2.3962.9183-3.3103 0-.9142-.9184-.9142-2.4072 0-3.3256zm0 0-3.6782-3.695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.9184 35.1619c-.9141-.9183-2.3962-.9183-3.3103 0-.9141.9184-.9141 2.4072 0 3.3256.9141.9183 2.3962.9183 3.3103 0 .9141-.9184.9141-2.4072 0-3.3256zm0 0 3.6782-3.695"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.6611,
    cy: 4.91734,
    fill: "#00cde2",
    opacity: 0.4,
    rx: 3.77476,
    ry: 3.7921
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.5372,
    cy: 43.9427,
    fill: "#00cde2",
    opacity: 0.4,
    rx: 3.77476,
    ry: 3.7921
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.2689,
    cy: 24.3758,
    fill: "#00cde2",
    opacity: 0.4,
    rx: 3.77476,
    ry: 3.7921
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.77476,
    cy: 24.6244,
    fill: "#00cde2",
    opacity: 0.4,
    rx: 3.77476,
    ry: 3.7921
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m26.5371 40.1665c-2.1532 0-3.8987 1.7536-3.8987 3.9167 0 2.1632 1.7455 3.9167 3.8987 3.9167 2.1533 0 3.8988-1.7535 3.8988-3.9167 0-2.1631-1.7455-3.9167-3.8988-3.9167zm0 0v-5.5952",
    stroke: "#00cde2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m26.5371 8.83336c-2.1532 0-3.8987-1.75355-3.8987-3.91668 0-2.16312 1.7455-3.91668 3.8987-3.91668 2.1533 0 3.8988 1.75356 3.8988 3.91668 0 2.16313-1.7455 3.91668-3.8988 3.91668zm0 0v3.91664",
    stroke: "#00cde2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDecentralized);
export default __webpack_public_path__ + "static/media/Icon-Decentralized.16f6e9d8306f76c4266b4700b6554886.svg";
export { ForwardRef as ReactComponent };